import { useContext } from 'react'
import { TimelineContext } from './timelineContextCore'

export const useTimeline = () => {
  const context = useContext(TimelineContext)
  if (!context) throw new Error('useTimeline must be used within TimelineProvider')
  return context
}
